import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.email) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bone)] px-6">
      <div className="w-full max-w-md bg-white border border-[var(--border)] p-10">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-full bg-[var(--oxblood)] text-white flex items-center justify-center mx-auto mb-5"><Lock className="w-5 h-5" /></div>
          <span className="font-display text-xl tracking-[0.15em]">STONECREST</span>
          <p className="text-xs uppercase tracking-[0.3em] text-[var(--muted)] mt-1">Admin Portal</p>
        </div>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-2">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-[var(--border)] px-4 py-3 focus:outline-none focus:border-[var(--oxblood)]" required />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[var(--muted)] mb-2">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-[var(--border)] px-4 py-3 focus:outline-none focus:border-[var(--oxblood)]" required />
          </div>
          {err && <p className="text-sm text-[var(--oxblood)]" data-testid="admin-error">{err}</p>}
          <button data-testid="admin-login-btn" disabled={loading} className="w-full bg-[var(--oxblood)] text-white py-3.5 tracking-wide hover:bg-[var(--oxblood-hover)] transition-colors flex items-center justify-center gap-2 disabled:opacity-50">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
